import { render } from "./StandardDetail.vue?vue&type=template&id=1e0f6ef0&scoped=true"
import script from "./StandardDetail.vue?vue&type=script&lang=ts"
export * from "./StandardDetail.vue?vue&type=script&lang=ts"

import "./StandardDetail.vue?vue&type=style&index=0&id=1e0f6ef0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e0f6ef0"

export default script